export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '/about',
  SERVICES: '/services',
  FACILITIES: '/facilities',
  PROJECTS: '/projects',
  GALLERY: '/gallery',
  CONTACT: '/contact',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  features: string[];
}

export interface Facility {
  id: string;
  name: string;
  description: string;
  image: string;
  specifications: string[];
}

export interface Equipment {
  id: string;
  category: string;
  name: string;
  specifications: string[];
  image?: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  quote: string;
  image?: string;
}

export interface Project {
  id: string;
  title: string;
  subtitle?: string;
  year: string;
  status: 'completed' | 'upcoming' | 'in-production';
  genre: string;
  description: string;
  image: string;
  cast?: string[];
  awards?: string[];
  highlights?: string[];
  website?: string;
  watchLinks?: {
    amazonPrime?: string;
    youtube?: string;
  };
}

export interface GalleryImage {
  id: string;
  title: string;
  category: 'studio' | 'production' | 'post-production' | 'events' | 'behind-scenes';
  image: string;
  description?: string;
}

export interface GalleryVideo {
  id: string;
  title: string;
  description: string;
  url: string;
  platform: 'youtube' | 'vimeo';
  category: 'profile' | 'trailers' | 'behind-scenes' | 'character-intro' | 'songs' | 'events';
  thumbnail?: string;
}